import BundleProvider from '../providers/BundleProvider'
import BundleListItem from '../components/BundleListItem/BundleListItem'

export default BundleProvider(BundleListItem)
